export enum PORTAL_TYPE {
  PORTAL = 'portal',
  PRE_PORTAL = 'pre-portal',
  DYNAMIC = 'dynamic',
  WALLET_WORKOUT = 'wallet-workout',
}

export enum CREDIT_REPORT_TOOLTIP_KEYS {
  PUBLIC_RECORDS_BANKRUPTCIES_AND_INSOLVENCIES = 'public-records-bankruptcies-and-insolvencies',
  PERSONAL_PERSONAL_INFORMATION = 'personal-personal-information',
  PERSONAL_OTHER_NAMES = 'personal-other-names',
  PUBLIC_RECORDS_CIFAS_FLAGS = 'public-records-cifas-flags',
  SUMMARY_CREDIT_CARDS = 'summary-credit-cards',
  SEARCH_HISTORY_SOFT_SEARCHES = 'search-history-soft-searches',
  PUBLIC_RECORDS_JUDGMENTS = 'public-records-judgments',
  WHAT_IS_A_CREDIT_SCORE = 'what-is-a-credit-score',
  ACCOUNTS_CURRENT_ACCOUNTS = 'accounts-current-accounts',
  ACCOUNTS_LOANS = 'accounts-loans',
  ACCOUNTS_OTHER = 'accounts-other',
  ACCOUNTS_TELECOMMUNICATIONS = 'accounts-telecommunications',
  PERSONAL_LINKED_ADDRESSES = 'personal-linked-addresses',
  PERSONAL_ELECTORAL_ROLL = 'personal-electoral-roll',
  ACCOUNTS_CREDIT_CARDS = 'accounts-credit-cards',
  ACCOUNTS_MORTGAGES = 'accounts-mortgages',
  ACCOUNTS_UTILITIES = 'accounts-utilities',
  SUMMARY_LOANS = 'summary-loans',
  SEARCH_HISTORY_HARD_SEARCHES = 'search-history-hard-searches',
  SUMMARY_MORTGAGES = 'summary-mortgages',
  PERSONAL_FINANCIAL_CONNECTIONS = 'personal-financial-connections',
}

export enum DISPUTE_TYPES {
  ADDRESS_LINK = 'ADDRESS_LINK',
  ALIAS_LINK = 'ALIAS_LINK',
  ASSOCIATE_LINK = 'ASSOCIATE_LINK',
  FINANCIAL_ACCOUNT_INFORMATION = 'FINANCIAL_ACCOUNT_INFORMATION',
  ELECTORAL_ROLL = 'ELECTORAL_ROLL',
  ELECTORAL_ROLL_NO_RECORD = 'ELECTORAL_ROLL_NO_RECORD',
  C_C_J = 'C_C_J',
  BANKRUPTCY_OR_SEQUESTRATION = 'BANKRUPTCY_OR_SEQUESTRATION',
  ADMINISTRATION_ORDER = 'ADMINISTRATION_ORDER',
  DEBT_RELIEF_ORDER = 'DEBT_RELIEF_ORDER',
  IVA_TRUST_DEED_OR_FAST_TRACK_VOLUNTARY_ARRANGEMENT = 'IVA_TRUST_DEED_OR_FAST_TRACK_VOLUNTARY_ARRANGEMENT',
  SEARCH_HISTORY = 'SEARCH_HISTORY',
}

export const enum ELIGIBILITY_SCORES {
  NO_CHANCE = -3,
  NA = -2,
  SPECIAL = -1,
  VWEAK = 0,
  WEAK = 2,
  FAIR = 4,
  STRONG = 7,
  VSTRONG = 9,
  PREAPPROVED = 10,
}

export const enum REGISTRATION_STATUSES {
  ACCOUNT_COMPLETED = 'ACCOUNT_COMPLETED',
  PROFILE_COMPLETED = 'PROFILE_COMPLETED',
  PROFILE_NEEDS_AMENDING_FOR_IDAAS = 'PROFILE_NEEDS_AMENDING_FOR_IDAAS',
  PROFILE_AMENDED_FOR_IDAAS = 'PROFILE_AMENDED_FOR_IDAAS',
}

export const enum CR_SUMMARY_ASSET_ELEMENT_TYPE {
  PROGRESS = 'ACCOUNT_PROGRESS',
  TOTAL = 'ACCOUNT_TOTAL',
}

export const enum CREDIT_REPORT_ASSET_ID {
  CREDIT_CARDS = 'CREDIT_CARDS',
  CURRENT_ACCOUNTS = 'CURRENT_ACCOUNTS',
  LOANS = 'LOANS',
  MORTGAGES = 'MORTGAGES',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  UTILITIES = 'UTILITIES',
  OTHER = 'OTHER',
  ACTIONS = 'ACTIONS',
  RECENT_CHANGES = 'RECENT_CHANGES',
  POSITIVE_REINFORCEMENTS = 'POSITIVE_REINFORCEMENTS',
  REPORT_INSIGHTS = 'REPORT_INSIGHTS',
}

export const enum CREDIT_REPORT_ACCOUNT_CLASSIFICATIONS {
  CREDIT_CARD = 'CREDIT_CARD',
  CURRENT_ACCOUNT = 'CURRENT_ACCOUNT',
  LOAN = 'LOAN',
  MORTGAGE = 'MORTGAGE',
  OTHER = 'OTHER',
  TELECOMMUNICATION = 'TELECOMMUNICATION',
  UTILITY = 'UTILITY',
}

export const enum ACCOUNT_VISIBILITY_TYPE {
  OPEN = 'open',
  CLOSED = 'closed',
}

export const enum SEARCH_HISTORY_ITEM_TYPE {
  SOFT = 'SOFT',
  HARD = 'HARD',
}

export const enum CREDIT_PROFILE_RESPONSE_TYPE {
  KBA_QUESTIONS = 'KBA_QUESTIONS',
  CREDIT_PROFILE = 'CREDIT_PROFILE',
  OTP_JOURNEY = 'OTP_JOURNEY',
  OTP_METADATA = 'OTP_METADATA',
}

export const enum IDENTIFICATION_OUTCOME {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NEGATIVE_OTP = 'NEGATIVE_OTP',
  THIN_FILE = 'THIN_FILE',
  KBA_VERIFICATION_REQUIRED = 'KBA_VERIFICATION_REQUIRED',
  LOCKED = 'LOCKED',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  KBA_VERIFICATION_FAILED = 'KBA_VERIFICATION_FAILED',
  OTP_VERIFICATION_REQUIRED = 'OTP_VERIFICATION_REQUIRED',
  OTP_OR_KBA_VERIFICATION_REQUIRED = 'OTP_OR_KBA_VERIFICATION_REQUIRED',
}

export const enum VALIDATE_OTP_OUTCOME {
  POSITIVE = 'POSITIVE',
  RETRY = 'RETRY',
  LOCKED = 'LOCKED',
  EXPIRED = 'EXPIRED',
}

export const enum CREDIT_REPORT_FORMAT {
  FULL = 'full',
  SHORT = 'short',
}

export enum SCORE_VALUES {
  'V. Weak' = 1,
  'Weak' = 2,
  'Fair' = 3,
  'Good' = 4,
  'V. Good' = 5,
}

export const enum CARD_TYPES {
  TOP_CARDS = 'top-cards',
  BALANCE_TRANSFER = 'balance-transfer',
  PURCHASES = 'purchases',
  BAD_CREDIT = 'bad-credit',
  REWARDS = 'rewards',
  BALANCE_TRANSFER_PURCHASE = 'balance-transfer-purchase',
  MONEY_TRANSFER = 'money-transfers',
  TRAVEL_MONEY = 'travel-money',
  AIRLINE = 'airline',
}

export const enum CONFIRM_DATA_ANSWERS {
  YES = 'yes',
  NO = 'no',
}

export const enum EMPLOYMENT_STATUS_LABELS {
  FULL_TIME = 'Full time',
  PART_TIME = 'Part time',
  SELF_EMPLOYED = 'Self employed',
  UNEMPLOYED = 'Unemployed',
  RETIRED = 'Retired',
  STUDENT = 'Student',
  HOMEMAKER = 'Homemaker',
}

export enum WALLET_WORKOUT_MESSAGE_TYPES {
  BOT,
  USER,
}

export enum CREDIT_SCORE_BAND {
  LOW = 'LOW',
  MEDHIGH = 'MEDHIGH',
}

export enum TITLE_LABELS {
  MR = 'Mr',
  MRS = 'Mrs',
  MISS = 'Miss',
  MS = 'Ms',
  DR = 'Dr',
  REV = 'Rev',
  OTHER = 'Other',
}

export enum MARITAL_STATUS_LABELS {
  DIVORCED = 'Divorced',
  MARRIED_OR_CIVIL_PARTNERSHIP = 'Married/Civil partnership',
  LIVING_WITH_PARTNER = 'Living with my partner',
  SINGLE = 'Single',
  WIDOWED = 'Widowed',
}

export enum RESIDENTIAL_STATUS_LABELS {
  HOMEOWNER = 'Homeowner',
  PRIVATE_TENANT = 'Private tenant',
  COUNCIL_TENANT = 'Council tenant',
  LIVING_WITH_PARENTS = 'Living with parents',
}

export enum UNEMPLOYED_BUSINESS_SECTOR_IDS {
  RETIRED = 522,
  HOMEMAKER = 520,
  STUDENT = 523,
  NOT_OR_SELF_EMPLOYED = 524,
}

export enum UNEMPLOYED_OCCUPATION_IDS {
  RETIRED = 1515,
  HOMEMAKER = 815,
  STUDENT = 1686,
  NOT_OR_SELF_EMPLOYED = 1876
}

export enum LOG_PREFIX {
  RECONFIRM_DETAILS = 'RECONFIRM DETAILS',
  EXISTS_OUTCOME = 'EXISTS OUTCOME',
  AFFORDABILITY = 'AFFORDABILITY',
  CARDS = 'CARDS',
  LOANS = 'LOANS',
  CREDIT_PROFILE = 'CREDIT PROFILE',
  FULL_CREDIT_PROFILE = 'FULL CREDIT PROFILE',
  DISPUTE = 'DISPUTE',
  FINANCIAL_ACCOUNT = 'FINANCIAL ACCOUNT',
  PROFILE = 'PROFILE',
  IS_VALID_PROFILE = 'IS VALID PROFILE',
  LOGOUT_AUTH = 'LOGOUT AUTH',
  OCCUPATIONS = 'OCCUPATIONS',
  BUSINESS_SECTORS = 'BUSINESS SECTORS',
  REGISTER_PROFILE = 'REGISTER PROFILE',
  MORTGAGE = 'MORTGAGE',
  DELETE_ACCOUNT = 'DELETE ACCOUNT',
  IDENTIFY_PROFILE = 'IDENTIFY PROFILE',
  RECONFIRM_FINANCE_DETAILS = 'RECONFIRM FINANCE DETAILS',
  AFFORDABILITY_REFRESH = 'AFFORDABILITY REFRESH',
  SEND_OTP = 'SEND OTP',
  VERIFY_OTP = 'VERIFY OTP',
  RESEND_OTP = 'RESEND OTP',
  GET_KBA_QUESTIONS = 'GET KBA QUESTIONS',
  VERIFY_KBA = 'VERIFY KBA',
  SETTINGS_PAGE = 'SETTINGS PAGE',
  APP = 'APP',
  ROUTING = 'ROUTING',
  AUTHENTICATED_USER = 'AUTHENTICATED USER',
  UNAUTHORISED = 'UNAUTHORISED',
  REAUTHENTICATION = 'REAUTHENTICATION',
  CC_SESSION_AUTH = 'CC_SESSION_AUTH',
  ALERTS = 'ALERTS',
  SIGNUP_QUESTIONS = 'SIGNUP QUESTIONS',
  RECAP = 'RECAP',
}

export enum URL_PARAMS {
  FROM_MSE = 'fromMse',
  GOAL = 'goal',
  ENQUIRY_ID = 'enquiryId',
  CASH_WITHDRAWAL = 'cashWithdrawal',
  BALANCE_TRANSFER_AMOUNT = 'balanceTransferAmount',
  CARD_INTENT = 'cardIntent',
  PRODUCT = 'product'
}

export enum STORAGE_KEYS {
  CARDS_QUESTION_SET_DATA = 'cardsQuestionSetData',
  LOANS_QUESTION_SET_DATA = 'loansQuestionSetData',
}